// Redux
import { useAppDispatch, useAppSelector } from 'app/hooks/useStore';
// Models
import { IValidateError } from 'app/store/DMSBatches/DMSBatches.models';
// Async
import {
  createFileUploadSession,
  createPreSignedUrlForFile,
  uploadFileByPreSignedUrl
} from 'app/store/DMSUploads/DMSUploads.async';
import { createBatch, validateBatch } from 'app/store/DMSBatches/DMSBatches.async';
// Actions
import { DMSUploadsActions } from 'app/store/DMSUploads/DMSUploads.slice';
// Selectors
import { selectPreSignedUrls } from 'app/store/DMSUploads/DMSUploads.selectors';
// Context
import useUploadContext from './useUploadContext';

let sessionId:any = null;

const useUploaderSubmit = (caseId: number) => {
  const dispatch = useAppDispatch();

  const preSignedUrls = useAppSelector(selectPreSignedUrls);

  const {
    onSetUploadedFilesCount,
    comment,
    fileItems,
    handleBuildErrorMap,
    handleSubmit,
    formState:{ isLoading, onSetIsLoading, isGooglePickerLoading }
  } = useUploadContext();

  const onSubmit = async () => handleSubmit(async () => {
    const s3Errors:(boolean | null)[] = [];
    const uploadData:any = { caseId, files: [] };

    if ( comment ) uploadData['comment'] = comment;

    onSetIsLoading(true);
    onSetUploadedFilesCount(0);

    try {
      // Used to preset error.references instead of using indexs
      // predefined id from fileItem
      const uploadedFileIdsByIndexes:string[] = []

      if ( !sessionId ){
        const response = await dispatch(createFileUploadSession({ caseId })).unwrap();
        sessionId = response.sessionId;
      }

      uploadData['sessionId'] = sessionId;

      for ( let i = 0; i < fileItems.length; i++ ){
        const { id, file, type, collectionId, name, comment } = fileItems[i];

        const newFile = new File([file], name, { type: file.type }) as File;

        const fileData:any = { name: newFile.name, type };

        if ( comment ) fileData['annotations'] = [{ name: 'comment', value: comment }];

        const preSignedData:any = {
          sessionId,
          file: {
            name: newFile.name,
            contentType: newFile.type
          },
          fileType: type
        };
        if ( collectionId ){
          fileData['collectionId'] = Number(collectionId);
          preSignedData['collectionId'] = Number(collectionId);
        }

        if ( !Object.keys(preSignedUrls).length || !preSignedUrls[id] ){
          const { url } = await dispatch(createPreSignedUrlForFile(preSignedData)).unwrap();
          const s3Error = await dispatch(uploadFileByPreSignedUrl({ url, file: newFile, index: i })).unwrap();
          if ( s3Error ){
            s3Errors[i] = true;
          }
          dispatch(DMSUploadsActions.addPreSignedUrl({ id, url }));
        } else {
          s3Errors[i] = null;
        }

        uploadData.files = [...uploadData.files, fileData];
        onSetUploadedFilesCount((prevState:number) => prevState + 1);
        uploadedFileIdsByIndexes.push(id);
      }

      if ( s3Errors.some((error:boolean | null) => error) ) return false;
      const validateErrors = await dispatch(validateBatch(uploadData)).unwrap();
      handleBuildErrorMap(validateErrors, uploadedFileIdsByIndexes);
      if ( validateErrors.some((error:IValidateError[]) => error.length) ) return false;
      await dispatch(createBatch(uploadData)).unwrap();
      return true;
    } catch(error){
      console.error(error);
      return false;
    } finally {
      onSetIsLoading(false);
    }
  });
  

  return { onSubmit, isLoading, isGooglePickerLoading };
};

export default useUploaderSubmit;
